import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    styled,
} from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormCheckbox from '../../shared/FormCheckbox';

const StyledTableCell = styled(TableCell)({
    paddingLeft: 0,
    paddingRight: 0,
});

const WeeklyDigestEmails = () => {
    const { control } = useFormContext();

    return (
        <div>
            <Table>
                <TableHead>
                    <TableRow>
                        <StyledTableCell
                            sx={{ width: '70%', borderBottom: 'none', py: 0 }}
                        >
                            <Typography variant='subHeading'>
                                Weekly Digest Notifications
                            </Typography>
                        </StyledTableCell>
                        <StyledTableCell
                            padding='checkbox'
                            align='center'
                            sx={{ borderBottom: 'none' }}
                        >
                            Email
                        </StyledTableCell>
                        <StyledTableCell
                            padding='checkbox'
                            align='center'
                            sx={{ borderBottom: 'none' }}
                        >
                            Mobile
                        </StyledTableCell>
                        <StyledTableCell
                            padding='checkbox'
                            align='center'
                            sx={{ borderBottom: 'none' }}
                        >
                            In-app
                        </StyledTableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    <TableRow>
                        <StyledTableCell>
                            <Typography>Weekly Digest</Typography>
                            Receive Weekly Digest Emails
                        </StyledTableCell>
                        <StyledTableCell padding='checkbox' align='center'>
                            <FormCheckbox
                                name='weeklyDigestEmailNotification'
                                control={control}
                            />
                        </StyledTableCell>
                        <StyledTableCell padding='checkbox' align='center'>
                            N/A
                        </StyledTableCell>
                        <StyledTableCell padding='checkbox' align='center'>
                            N/A
                        </StyledTableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    );
};

export default WeeklyDigestEmails;
